<template>
  <div class="asking-mic-queue" @click.stop>
    <div class="application-box">
      <el-button round class="btn-mic" @click="init()">
        <i class="icon-voice">
          <img src="../images/voice.png" alt="" />
        </i>
        {{ applicationCount ? applicationCount + $t('components_voiceroom_component_asking_mic_queue_1834') : $t('components_voiceroom_component_action_page_1830') }}
      </el-button>
    </div>

    <div class="main" v-show="visible">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('components_voiceroom_component_asking_mic_queue_1835')" name="application">
          <ul class="user-box">
            <li class="user-item" v-for="item of list" :key="item.id">
              <div class="left">
                <img class="avatar" :src="item.avatarUrl" alt="" />
                <div>
                  <div class="top">
                    <span class="user-name">{{ item.nickname }}</span>
                  </div>
                  <div class="user-level-wrap">
                    <div
                      class="userlevel-tag"
                      v-if="item.userLevel"
                      :class="`level-${item.userLevel}`"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="right">
                <button class="btn-reject" @click="rejectApplyMic(item)">{{$t('components_order_order_card_520')}}</button>
                <button class="btn-agree" @click="agreeMic(item)">{{$t('components_order_order_card_521')}}</button>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane :label="$t('components_voiceroom_component_asking_mic_queue_1836')" name="invitation">
          <div class="invite-user-box">
            <div class="search">
              <input
                ref="search"
                type="text"
                v-model.trim="searchVal"
                :placeholder="$t('upgrade_page_layout_header_14')"
                @keyup.enter="searchOnlineMembers(searchVal)"
              />
              <div class="icon" @click="searchOnlineMembers(searchVal)">
                <fps-icon type="search" size="20" />
              </div>
            </div>
            <ul class="invite-user">
              <li
                class="user-item"
                v-for="item of onlineMembers"
                :key="item.id"
              >
                <div class="left">
                  <img class="avatar" :src="item.avatarUrl" alt="" />
                  <div>
                    <div class="top">
                      <span class="user-name">{{ item.userNickname }}</span>
                    </div>
                    <div class="user-level-wrap">
                      <div
                        class="userlevel-tag"
                        v-if="item.userLevel"
                        :class="`level-${item.userLevel}`"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <button
                    class="btn-agree"
                    @click="
                      agreeMic({
                        avatarUrl: item.avatarUrl,
                        nickname: item.userNickname,
                        sex: item.sex,
                        Male: item.Male,
                        spendAmount: item.spendAmount,
                        userLevel: item.userLevel,
                        uuid: item.userUuid
                      })
                    "
                  >{{$t('components_voiceroom_component_asking_mic_queue_1836')}}</button>
                </div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import {
  askingMicQueue,
  rejectApplyMic as rejectApplyMicRequest,
  agreeApplyMic as agreeApplyMicRequest,
  searchOnlineMembers as searchOnlineMembersRequest
} from '@/api/voice-room';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import SeatProvider from '@/components/VoiceRoom/seatProvider';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
export default {
  name: 'AskingMicQueue',
  props: {},
  data() {
    return {
      activeName: 'application',
      list: [],
      visible: false,
      loading: false,
      applicationCount: 0,
      searchVal: '',
      searchLoading: false,
      voiceRoomMembers: []
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    },
    emptySeatIndex() {
      return SeatProvider.emptySeatIndex;
    },
    seatList() {
      return SeatProvider.list;
    },
    onlineMembers() {
      return this.voiceRoomMembers.filter(item => {
        return this.seatList.every(seat => {
          return (
            !seat.user ||
            (seat.user &&
              seat.user.userId != item.userUuid &&
              this.uuid != item.userUuid)
          );
        });
      });
    }
  },
  methods: {
    init() {
      this.visible = true;
      document.body.addEventListener('click', this.closeDialog);
      this.getList();
      this.searchOnlineMembers();
    },
    closeDialog() {
      this.visible = false;
      document.body.removeEventListener('click', this.closeDialog);
    },
    async getList() {
      try {
        const params = {};
        params['roomUid'] = this.roomId;
        const { data } = await askingMicQueue(params);
        this.list = data;
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomId, fun: 'askingMicQueue-getList' },
          error
        );
      }
    },
    /**
     * @description: 拒絕上麥申請
     * @param {*} userInfo
     * @return {*}
     */
    async rejectApplyMic(userInfo) {
      try {
        let params = {};
        params['roomUid'] = this.roomId;
        params['action'] = 'RemoveAskingMic';
        params['targetUuid'] = userInfo.uuid;
        await rejectApplyMicRequest(params);
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomId, fun: 'rejectApplyMic' },
          error
        );
        this.$message.error(i18n.t('components_userrelation_index_249'));
      }
    },

    async agreeMic(userInfo) {
      try {
        if (this.emptySeatIndex == -1) {
          this.$message.error(i18n.t('components_voiceroom_component_asking_mic_queue_1837'));
          return;
        }
        let params = {};
        params['roomUid'] = this.roomId;
        params['action'] = 'AgreeAskingMic';
        params['targetUuid'] = userInfo.uuid;
        await agreeApplyMicRequest(params);
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomId, fun: 'agreeMic' },
          error
        );
      }
    },

    async searchOnlineMembers(searchVal) {
      if (this.searchLoading) return;
      try {
        const { data } = await searchOnlineMembersRequest({
          keywords: searchVal,
          pageIndex: 0,
          roomUid: this.roomId
        });
        this.voiceRoomMembers = data.voiceRoomMembers;
      } catch (error) {
        console.log(error);
      } finally {
        this.searchLoading = false;
      }
    }
  },
  created() {
    VoiceRoomEventEmitter.on(VoiceRoomEvent.updateAskingMicQueue, num => {
      this.applicationCount = num;
      if (this.visible) {
        this.getList();
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.asking-mic-queue {
  font-size: 0;
}
.application-box {
  position: relative;
}
.main {
  font-size: 14px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #101024;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  z-index: 2;
  .user-box {
    height: 300px;
    overflow: auto;
  }

  .user-item {
    display: flex;
    color: white;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .left {
      display: flex;
      .user-name {
        margin-right: 10px;
        margin-bottom: 4px;
        max-width: 200px;
        @include ellipsis;
      }
    }
    .right {
      .btn-reject {
        color: #4bc9f1;
      }
      .btn-agree {
        color: #242632;
        padding: 6px 10px;
        border-radius: 20px;
        background: #4bc9f1;
        margin-left: 10px;
      }
    }
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 20px;
      object-fit: cover;
    }
    .top {
      display: flex;
      align-items: center;
    }
  }
  .btn-mic {
    color: white;
    font-size: 14px;
    border-radius: 42px;
    background: rgba(255, 255, 255, 0.12);
    padding: 0 24px 0 19px;
    border: none;
    margin-right: 10px;
    display: flex;
    align-items: center;

    /deep/ span {
      display: flex;
      align-items: center;
      height: 44px;
    }
    .icon-voice {
      display: inline-block;
      img {
        width: 19px;
        height: 19px;
        margin-right: 7px;
      }
    }
  }
}
.invite-user-box {
  height: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.search {
  @include flex;
  width: 100%;
  height: 32px;
  color: $color-split;
  background: rgba(232, 234, 238, 0.4);
  border: 1px solid rgba(140, 148, 170, 0.1);
  border-radius: 32px;

  input {
    flex-grow: 1;
    margin-left: 16px;
    line-height: 14px;
    color: $color-gray-1;
    font-size: 14px;
    padding: 8px 0;

    &::placeholder {
      line-height: 14px;
      color: $color-gray-3;
      font-size: 14px;
      font-weight: 300;
      opacity: 0.5;
    }
  }

  .icon {
    flex-shrink: 0;
    margin-right: 12px;
    width: 32px;
    height: 32px;
    padding: 6px;
    color: #d6d9e1;
    cursor: pointer;
  }

  &:focus,
  &.active {
    border: 1px solid rgba(140, 148, 170, 0.4);

    .icon {
      color: $color-gray-1;
    }
  }
}
.invite-user {
  width: 100%;
  flex: 1;
  overflow: auto;
  height: 1px;
  padding: 20px 0;
}
</style>
<style lang="scss">
.asking-mic-queue {
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    color: white;
    &.is_active {
      color: yellow;
    }
  }
}
</style>
